import { HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";
import { DateTimeRenderer } from "../../generic/DateTimeRenderer";

import styles from "./style.module.scss";

export type SimpleHistoryItem = {
  id: any,
  timestamp: string,
  description?: string,
  type: "successful" | "neutral" | "unsuccessful"
}

export type SimpleHistoryTimelineProps = {
  history: SimpleHistoryItem[],
  dateFormat?: string,
  timeZone?: string
} & HtmlHTMLAttributes<HTMLDivElement>

export const SimpleHistoryTimeline = memo<SimpleHistoryTimelineProps>((
  {
    history,
    className,
    dateFormat,
    timeZone,
    children,
    ...rest
  }) => {
  return (
    <div {...rest} className={classNames(styles.root, className)}>
      {history.map(x =>
        <div key={x.id} className={classNames(styles.card, styles[x.type])}>
          <div className={styles.date}>
            <DateTimeRenderer value={x.timestamp} dateFormat={dateFormat} timeZone={timeZone} />
          </div>
          <div className={styles.description}>
            {x.description}
          </div>
        </div>)}
    </div>
  );
});

export default SimpleHistoryTimeline;
